import ScrollMagic from 'ScrollMagic';

export function animation() {
    // setTimeout(() => {
window.addEventListener("load", function(){
    let controller = new ScrollMagic.Controller();
    // const sceneAdd = (element) => {
    //     let scene = new ScrollMagic.Scene({ triggerElement: element, triggerHook: .8, })
    //         .on('enter', () => {
    //             element.classList.add('action');
    //         })
    //         .addTo(controller);
    // }
    const sceneAdd = (element) => {
    let scene = new ScrollMagic.Scene({ triggerElement: element, triggerHook: 0.8 })
        .on('enter', () => {
            // 1フレーム遅延させて class を付与
            requestAnimationFrame(() => {
                element.classList.add('action');
            });
        })
        .addTo(controller);
}


    //start
    const anime = document.querySelectorAll('.j-animation');
    const fadein = document.querySelectorAll('.j-fadein');
    const fadeleft = document.querySelectorAll('.j-fadeleft');
    const faderight = document.querySelectorAll('.j-faderight');
    const fadeup = document.querySelectorAll('.j-fadeup');
    const slide = document.querySelectorAll('.j-slide');
    const slideup = document.querySelectorAll('.j-slideup');
    const lineAnimation = document.querySelectorAll('.c-line-animation');
    const scrollShow = document.querySelectorAll('.c-scrollShow');

    Array.prototype.forEach.call(anime, (el, i) => {
        sceneAdd(el);
    });
    Array.prototype.forEach.call(fadein, (el, i) => {
        sceneAdd(el);
    });
    Array.prototype.forEach.call(fadeleft, (el, i) => {
        sceneAdd(el);
    });
    Array.prototype.forEach.call(faderight, (el, i) => {
        sceneAdd(el);
    });
    Array.prototype.forEach.call(fadeup, (el, i) => {
        sceneAdd(el);
    });
    Array.prototype.forEach.call(slide, (el, i) => {
        sceneAdd(el);
    });
    Array.prototype.forEach.call(slideup, (el, i) => {
        sceneAdd(el);
    });
    Array.prototype.forEach.call(lineAnimation, (el, i) => {
        sceneAdd(el);
    });
    Array.prototype.forEach.call(scrollShow, (el, i) => {
        sceneAdd(el);
    });
// }, 50);
});
}